import classNames from 'clsx';

import flashUltra from '../assets/tiles/promo/spingo-promo-1m-flash.png';
import holdemUltra from '../assets/tiles/promo/spingo-promo-1m-holdem.png';
import maxHigh from '../assets/tiles/spingo-max-high.png';
import omahaHigh from '../assets/tiles/spingo-omaha-high.png';
import { ENDPOINTS } from '../constants';
import styles from '../styles/shared.scss';
import type { GameTypeName, GameTypeUrl } from '../types/Game';
import { GAME_TYPE_URL_MAP, GameStake, GameType } from '../types/Game';

const HOLDEM = 'spingo--holdem-';
const FLASH = 'spingo--flash-';
const MAX = 'spingo--max-';
const OMAHA = 'spingo--omaha-';

export const DEFAULT_PROMO_IMAGE = {
  [GameType.Holdem]: holdemUltra,
  [GameType.HoldemFlash]: flashUltra,
  [GameType.Omaha]: omahaHigh,
  [GameType.HoldemMax]: maxHigh
};

export const getPromoAsset = (promoRef: string, locale: string) => {
  const searchParams = new URLSearchParams({ promoRef, locale });

  return ENDPOINTS.tileBackground + `?${searchParams.toString()}`;
};

const GAME_STAKE_CLASS_MAP = {
  [GameType.Holdem]: {
    [`${HOLDEM}${GameStake.MICRO}`]: classNames(styles.holdem, styles.micro),
    [`${HOLDEM}${GameStake.LOW}`]: classNames(styles.holdem, styles.low),
    [`${HOLDEM}${GameStake.MEDIUM}`]: classNames(styles.holdem, styles.medium),
    [`${HOLDEM}${GameStake.HIGH}`]: classNames(styles.holdem, styles.high),
    [`${HOLDEM}${GameStake.ULTRA}`]: classNames(styles.holdem, styles.ultra),
    default: classNames(styles.holdem, styles.low)
  },
  [GameType.HoldemFlash]: {
    [`${FLASH}${GameStake.MICRO}`]: classNames(styles.flash, styles.micro),
    [`${FLASH}${GameStake.LOW}`]: classNames(styles.flash, styles.low),
    [`${FLASH}${GameStake.MEDIUM}`]: classNames(styles.flash, styles.medium),
    [`${FLASH}${GameStake.HIGH}`]: classNames(styles.flash, styles.high),
    [`${FLASH}${GameStake.ULTRA}`]: classNames(styles.flash, styles.ultra),
    default: classNames(styles.flash, styles.low)
  },
  [GameType.HoldemMax]: {
    [`${MAX}${GameStake.MICRO}`]: classNames(styles.max, styles.micro),
    [`${MAX}${GameStake.LOW}`]: classNames(styles.max, styles.low),
    [`${MAX}${GameStake.MEDIUM}`]: classNames(styles.max, styles.medium),
    [`${MAX}${GameStake.HIGH}`]: classNames(styles.max, styles.high),
    [`${MAX}${GameStake.ULTRA}`]: classNames(styles.max, styles.ultra),
    default: classNames(styles.max, styles.low)
  },
  [GameType.Omaha]: {
    [`${OMAHA}${GameStake.MICRO}`]: classNames(styles.omaha, styles.micro),
    [`${OMAHA}${GameStake.LOW}`]: classNames(styles.omaha, styles.low),
    [`${OMAHA}${GameStake.MEDIUM}`]: classNames(styles.omaha, styles.medium),
    [`${OMAHA}${GameStake.HIGH}`]: classNames(styles.omaha, styles.high),
    [`${OMAHA}${GameStake.ULTRA}`]: classNames(styles.omaha, styles.ultra),
    default: classNames(styles.omaha, styles.low)
  }
};

export const getBackgroundClasses = (url: GameTypeUrl, gameType: GameTypeName) =>
  // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
  GAME_STAKE_CLASS_MAP[gameType][url[GAME_TYPE_URL_MAP[gameType]]] ||
  GAME_STAKE_CLASS_MAP[gameType].default;
